import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { flyerLogAPI } from "api/Interactions/FlyersAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface FlyersBottomDrawerProps {
  flyerId: number;
}

const FlyersBottomDrawer: React.FC<FlyersBottomDrawerProps> = ({ flyerId }) => {
  const fetchLogs = useCallback(() => flyerLogAPI.getAllByParentId(flyerId), [flyerId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime" },
    { field: "street_address", label: "Street Address", type: "text" },
    { field: "city", label: "City", type: "text" },
    { field: "country", label: "Country", type: "text" },
    { field: "success", label: "Success", type: "boolean" },
  ];
  
  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Flyer Delivery Logs"
    />
  );
};

export default FlyersBottomDrawer;
